import { useEffect } from 'react';

export const LoadingEventType = 'build';
export interface LoadingEvent {
  isLoading: boolean;
}

export default function useSystemLoading(loading: boolean, disabled?: boolean): void {
  useEffect(() => {
    if (!disabled)
      document.dispatchEvent(new CustomEvent<LoadingEvent>(LoadingEventType, { detail: { isLoading: loading } }));

    return () => {
      if (!disabled)
        document.dispatchEvent(new CustomEvent<LoadingEvent>(LoadingEventType, { detail: { isLoading: false } }));
    };
  }, [loading, disabled]);
}
